<template>
  <Transition name="select-item-type-overlay">
    <div
      v-if="showItemTypeModal"
      class="select-item-type-modal-overlay select-item-type-modal-overlay--glass"
      @click.self="closeModal"
    >
      <Transition name="select-item-type-panel" appear>
        <div
          class="select-item-type-modal select-item-type-modal--glass"
          role="dialog"
          aria-labelledby="modal-title"
          @click.stop
        >
          <div class="select-item-type-modal-header select-item-type-modal-header--glass">
            <h2 id="modal-title" class="select-item-type-modal-title">
              <i class="bi bi-grid-3x3-gap-fill select-item-type-modal-title__icon" aria-hidden="true"></i>
              Select Item Type
            </h2>
            <div class="select-item-type-modal-header-actions">
              <button
                type="button"
                class="select-item-type-icon-btn"
                aria-label="Help"
                title="Help"
                @click="showHelp"
              >
                <i class="bi bi-question-circle" aria-hidden="true"></i>
              </button>
              <button
                type="button"
                class="select-item-type-icon-btn select-item-type-icon-btn--close"
                aria-label="Close"
                title="Close"
                @click="closeModal"
              >
                <i class="bi bi-x-lg" aria-hidden="true"></i>
              </button>
            </div>
          </div>

          <div class="select-item-type-modal-body select-item-type-modal-body--glass">
            <div class="select-item-type-options" role="radiogroup" aria-label="Item type options">
              <label
                v-for="(option, index) in itemTypeOptions"
                :key="option.value"
                class="select-item-type-radio-option"
                :class="{
                  selected: selectedType === option.value,
                  [`select-item-type-radio-option--${index + 1}`]: true,
                }"
              >
                <input
                  type="radio"
                  v-model="selectedType"
                  :value="option.value"
                  name="itemType"
                />
                <div class="select-item-type-option-content">
                  <span class="select-item-type-radio-control" aria-hidden="true"></span>
                  <i v-if="option.icon" :class="option.icon" class="select-item-type-option-icon" aria-hidden="true"></i>
                  <span class="select-item-type-radio-label">{{ option.label }}</span>
                </div>
              </label>
            </div>
          </div>

          <div class="select-item-type-modal-footer select-item-type-modal-footer--glass">
            <SecondaryButton label="Cancel" icon="bi bi-x-lg" @click="closeModal" />
            <PrimaryButton label="Continue" icon="bi bi-arrow-right" @click="ok" />
          </div>
        </div>
      </Transition>
    </div>
  </Transition>
</template>

<script>
import logger from '@/utils/logger';
import './SelectItemType.css';
import PrimaryButton from '@/modules/consultant/components/PrimaryButton.vue';
import SecondaryButton from '@/modules/consultant/components/SecondaryButton.vue';

const DEFAULT_ITEM_TYPE = 'Service Item';

export default {
  name: 'SelectItemType',
  components: { PrimaryButton, SecondaryButton },
  props: {
    modelValue: {
      type: String,
      default: DEFAULT_ITEM_TYPE,
    },
  },
  data() {
    return {
      selectedType: DEFAULT_ITEM_TYPE,
      showItemTypeModal: true,
      itemTypeOptions: [
        { value: DEFAULT_ITEM_TYPE, label: 'Service Item', icon: 'bi bi-briefcase' },
        { value: 'Inventory Item', label: 'Inventory Item', icon: 'bi bi-box-seam' },
        { value: 'Non Inventory Item', label: 'Non Inventory Item', icon: 'bi bi-box' },
        { value: 'Inventory Assembly', label: 'Inventory Assembly', icon: 'bi bi-diagram-3' },
        { value: 'Add New Consultant', label: 'Add New Consultant', icon: 'bi bi-person-plus' },
      ],
    };
  },
  mounted() {
    this.applyDefaultSelection();
  },
  watch: {
    modelValue(val) {
      this.selectedType = val || DEFAULT_ITEM_TYPE;
    },
  },
  methods: {
    applyDefaultSelection() {
      this.selectedType = DEFAULT_ITEM_TYPE;
      this.$emit('update:modelValue', DEFAULT_ITEM_TYPE);
    },
    showHelp() {
      logger.log('Show help');
    },
    ok() {
      this.$emit('update:modelValue', this.selectedType);
      this.$emit('ok', this.selectedType);
      this.showItemTypeModal = false;
      this.navigateToItemType();
    },
    navigateToItemType() {
      const currentCompanyId = this.$route.params.id;

      switch (this.selectedType) {
        case 'Service Item':
          this.$router.push({ name: 'NewCustomerServiceItem', params: { id: currentCompanyId } });
          break;
        case 'Inventory Item':
          this.$router.push({ name: 'NewCustomerInventoryItem', params: { id: currentCompanyId } });
          break;
        case 'Non Inventory Item':
          this.$router.push({ name: 'NewCustomerNonInventoryItem', params: { id: currentCompanyId } });
          break;
        case 'Inventory Assembly':
          this.$router.push({ name: 'NewCustomerInventoryAssembly', params: { id: currentCompanyId } });
          break;
        case 'Add New Consultant':
          this.$router.push({ name: 'AddCustomerConsultant', params: { id: currentCompanyId } });
          break;
        default:
          logger.warn('Unknown item type:', this.selectedType);
      }
    },
    closeModal() {
      this.showItemTypeModal = false;
      this.$emit('cancel');
    },
  },
};
</script>
